// Statuses should be in sync with the backend
// https://bitbucket.org/modulusdevelopment/powerboard-backend/src/develop/powerboard-backend/src/main/scala/com/planetos/powerboard/backend/InternalEntities.scala#lines-380

export const WS_STATUSES = {
    STOPPED_MANUAL: 'stopped-manual',
    STOPPED: 'stopped',
    ALARM_STOPPED: 'alarm-stopped',
    NO_COMM: 'no-communication',
    CURTAILED: 'start',
    AVAILABLE: 'normal',
    IN_SERVICE: 'in-service',
    ALARM_RUNNING: 'alarm-running',
};
